import i18n from 'i18next';
import React from 'react';
import {
  ChargerEV,
  CompanyBuilding,
  Dashboard,
  LicensesIcon,
  LockPrivacy,
  PayoutMoney,
  Power as PowerIcon,
  Pricing as PricingIcon,
  RFIDCard,
  Reports,
  Settings,
  Vehicle,
} from './assets/icons';
import NoCompanyAccess from './components/_ui/No-company-access.component';
import { Access } from './components/Access/Access.component';
import { Chargers } from './components/Charger';
import { ChargerDetail } from './components/Charger/ChargerDetail.component';
import { Company } from './components/company/Company.component';
import SiteHostLicenses from './components/Licenses/SiteHostLicenses.component';
import SupportLicenses from './components/Licenses/SupportLicenses.component';
import { Overview } from './components/overview';
import { Payouts } from './components/Payouts/Payouts.component';
import { Power } from './components/Power/Power.component';
import { EditPricingRules } from './components/Pricing/EditPricingRules.component';
import { Pricing } from './components/Pricing/Pricing.component';
import { PromotionDetailsPage } from './components/Promotion/PromotionForm/PromotionDetailsPage.component';
import { Report } from './components/reports/Report.component';
import { Rfid } from './components/RFID/Rfid.component';
import { ChargerModelEdit } from './components/support/ChargerModels/ChargerModelEdit.component';
import { ChargerModels } from './components/support/ChargerModels/ChargerModels.component';
import { OcppTimelogPage } from './components/support/OcppTimelog/OcppTimelogPage.component';
import { PriceGuardrails } from './components/support/PriceGuardrails/PriceGuardrails.component';
import { VehicleDetails } from './components/Vehicles/VehicleDetails.component';
import { Vehicles } from './components/Vehicles/Vehicles.component';
import { USER_ROLE } from './hooks';

export enum RoutePath {
  LOGIN = '/login',
  ONBOARDING = 'onboarding',
  CREATE_COMPANY_SELF_SERVE = 'createCompanySelfServe',
  OVERVIEW = 'overview',
  CHARGERS = 'chargers',
  CHARGER_DETAIL = 'chargers/:chargerId',
  CHARGER_MESSAGE = '/:chargerId/:receivedTime/message',
  PRICING = 'pricing',
  PRICING_EDIT = 'pricingedit',
  ACCESS = 'access',
  COMPANY = 'company',
  PAYOUT = 'payout',
  RFID = 'rfid',
  LEARNING = 'learing',
  HELP = 'help',
  VEHICLES = 'vehicles',
  NO_ACCESS = 'noaccess',
  VEHICLE_DETAIL = 'vehicles/:vehicleId',
  NO_ROUTE_PERMISSION = '/noRoutePermission',
  POWER = 'power',
  REPORTS = 'reports',
  NOT_FOUND = '/pageNotFound',
  SPARK_RESULTS = '/spark-result-viewer',
  SPARK_RESULTS_V3 = '/spark-result-viewer-v3',
  LICENSES = 'licenses',
  LICENSE_SELF_RENEWAL_SUCCESS = 'licenses/renewal-success',
  PRICE_GUARDRAILS = 'support/price-guardrails',
  CHARGER_MODELS = 'support/chargermodels',
  CHARGER_MODEL_EDIT = 'support/chargermodels/:chargerModelId',
  OCPP_TIMELOG = 'support/ocpp-timelog',
  PROMOTIONS = 'promotions',
  PROMOTION_VIEW = 'promotions/:promotionId',
  PROMOTION_NEW = 'promotions/new',
  PROMO_CODE_NEW = 'promocode/:promotionId/new',
}

export const multiCompanyRoutes = [
  '/',
  '/overview',
  '/chargers',
  '/chargers/:chargerId',
  '/reports',
];

export const supportUserMultiCompanyRoutes = [
  '/',
  '/chargers',
  '/chargers/:chargerId',
  '/reports',
  '/support/price-guardrails',
  '/support/chargermodels',
  '/support/ocpp-timelog',
];

export interface Route {
  name: string;
  path: RoutePath;
  component: React.ComponentType<any>;
  icon: string;
  role?: USER_ROLE;
}

export const routes: Route[] = [
  {
    name: 'overview',
    path: RoutePath.OVERVIEW,
    component: Overview,
    icon: Dashboard,
  },
  {
    name: 'chargers',
    path: RoutePath.CHARGERS,
    component: Chargers,
    icon: ChargerEV,
  },
  {
    name: 'charger_detail',
    path: RoutePath.CHARGER_DETAIL,
    component: ChargerDetail,
    icon: ChargerEV,
  },
  {
    name: 'pricing',
    path: RoutePath.PRICING,
    component: Pricing,
    icon: PricingIcon,
  },
  {
    name: 'pricing',
    path: RoutePath.PRICING_EDIT,
    component: EditPricingRules,
    icon: PricingIcon,
  },
  {
    name: 'add_promotion_title',
    path: RoutePath.PROMOTION_NEW,
    component: PromotionDetailsPage,
    icon: PricingIcon,
  },
  {
    name: 'view_promotion',
    path: RoutePath.PROMOTION_VIEW,
    component: PromotionDetailsPage,
    icon: PricingIcon,
  },
  {
    name: 'access',
    path: RoutePath.ACCESS,
    component: Access,
    icon: LockPrivacy,
  },
  {
    name: 'power',
    path: RoutePath.POWER,
    component: Power,
    icon: PowerIcon,
  },
  {
    name: 'revenue',
    path: RoutePath.PAYOUT,
    component: Payouts,
    icon: PayoutMoney,
  },
  {
    name: 'company',
    path: RoutePath.COMPANY,
    component: Company,
    icon: CompanyBuilding,
  },

  // {
  //   name:
  //   path: RoutePath.LEARNING,
  //   component: ,
  // },
  {
    name: 'rfid',
    path: RoutePath.RFID,
    component: Rfid,
    icon: RFIDCard,
  },
  // {
  //   name:
  //   path: RoutePath.HELP,
  //   component: ,
  // },
  {
    name: 'vehicles',
    path: RoutePath.VEHICLES,
    component: Vehicles,
    icon: Vehicle,
  },
  {
    name: 'vehicles',
    path: RoutePath.VEHICLE_DETAIL,
    component: VehicleDetails,
    icon: Vehicle,
  },
  {
    name: 'noaccess',
    path: RoutePath.NO_ACCESS,
    component: NoCompanyAccess,
    icon: Dashboard,
  },
  {
    name: 'reports',
    path: RoutePath.REPORTS,
    component: Report,
    icon: Reports,
  },
  {
    name: 'licenses',
    path: RoutePath.LICENSES,
    component: SupportLicenses,
    icon: LicensesIcon,
    role: USER_ROLE.SUPPORT,
  },
  {
    name: 'licenses',
    path: RoutePath.LICENSES,
    component: SiteHostLicenses,
    icon: LicensesIcon,
    role: USER_ROLE.NORMAL,
  },
  {
    name: 'license_self_renewal_success',
    path: RoutePath.LICENSE_SELF_RENEWAL_SUCCESS,
    component: SupportLicenses,
    icon: LicensesIcon,
    role: USER_ROLE.SUPPORT,
  },
  {
    name: 'license_self_renewal_success',
    path: RoutePath.LICENSE_SELF_RENEWAL_SUCCESS,
    component: SiteHostLicenses,
    icon: LicensesIcon,
    role: USER_ROLE.NORMAL,
  },
  {
    name: 'support_section.price_guardrails',
    path: RoutePath.PRICE_GUARDRAILS,
    component: PriceGuardrails,
    icon: Settings,
    role: USER_ROLE.SUPPORT,
  },
  {
    name: 'support_section.charger_models',
    path: RoutePath.CHARGER_MODELS,
    component: ChargerModels,
    icon: ChargerEV,
    role: USER_ROLE.SUPPORT,
  },
  {
    name: 'support_section.charger_models_edit_title',
    path: RoutePath.CHARGER_MODEL_EDIT,
    component: ChargerModelEdit,
    icon: ChargerEV,
    role: USER_ROLE.SUPPORT,
  },
  {
    name: 'support_section.ocpp_timelog',
    path: RoutePath.OCPP_TIMELOG,
    component: OcppTimelogPage,
    icon: Reports,
    role: USER_ROLE.SUPPORT,
  },
  // TODO: pending to add 'add promotion', 'view promotion', 'add promo code' etc.
  /*
  {
    name: 'add_promotion',
    path: RoutePath.PROMOTION_NEW,
    component: PromotionNew,
    icon: Promotion,
    role: USER_ROLE.NORMAL,
  },
  {
    name: 'view_promotion',
    path: RoutePath.PROMOTION_VIEW,
    component: PromotionView,
    icon: Promotion,
    role: USER_ROLE.NORMAL,
  },
  {
    name: 'add_promo_code',
    path: RoutePath.PROMO_CODE_NEW,
    component: PromoCodeNew,
    icon: PromoCode,
    role: USER_ROLE.NORMAL,
  },
  */
];

export type GroupItem = {
  path: RoutePath;
  icon: string;
  index?: number;
  ignoreClick?: boolean;
  isDisabled?: boolean;
  isHidden?: boolean;
  isSelected?: boolean;
  color?: string;
  role?: USER_ROLE;
};
type SideBarMenu = {
  header?: string;
  items: GroupItem[];
  role?: USER_ROLE;
};
export const sideBarMenus: SideBarMenu[] = [
  {
    items: [
      {
        path: RoutePath.OVERVIEW,
        icon: Dashboard,
        index: 0,
      },
    ],
  },
  {
    header: 'side_bar_charger_management',
    items: [
      {
        path: RoutePath.CHARGERS,
        icon: ChargerEV,
        index: 1,
      },
      { path: RoutePath.PRICING, icon: PricingIcon, index: 2 },
      { path: RoutePath.ACCESS, icon: LockPrivacy, index: 3 },
      { path: RoutePath.POWER, icon: PowerIcon, index: 4 },
    ],
  },
  {
    header: 'side_bar_fleet_management',
    items: [{ path: RoutePath.VEHICLES, icon: Vehicle, index: 5 }],
  },
  {
    header: 'side_bar_admin',
    items: [
      { path: RoutePath.COMPANY, icon: CompanyBuilding, index: 6 },
      { path: RoutePath.REPORTS, icon: Reports, index: 7 },
      { path: RoutePath.PAYOUT, icon: PayoutMoney, index: 8 },
      { path: RoutePath.RFID, icon: RFIDCard, index: 9 },
      {
        path: RoutePath.LICENSES,
        icon: LicensesIcon,
        index: 10,
      },
    ],
  },
  {
    header: 'support_section.side_bar_title',
    items: [
      {
        path: RoutePath.PRICE_GUARDRAILS,
        icon: Settings,
        index: 11,
        role: USER_ROLE.SUPPORT,
      },
      {
        path: RoutePath.CHARGER_MODELS,
        icon: ChargerEV,
        index: 12,
        role: USER_ROLE.SUPPORT,
      },
      {
        path: RoutePath.OCPP_TIMELOG,
        icon: Reports,
        index: 13,
        role: USER_ROLE.SUPPORT,
      },
    ],
    role: USER_ROLE.SUPPORT,
  },
];

export const getBaseRoute = (fullPath: string) => {
  const arr = fullPath.split('/');
  return arr?.length >= 2 ? arr[1] : arr[0];
};

export const getRouteTitle = (fullpath: string) => {
  if (fullpath === '/' || fullpath === '/noaccess') {
    return 'overview';
  }
  if (fullpath === '/power') {
    return i18n.t('power_management');
  }

  const baseRoute = getBaseRoute(fullpath);
  const normalizedPath = fullpath.startsWith('/') ? fullpath.slice(1) : fullpath;
  if (normalizedPath === `${RoutePath.CHARGER_MODELS}/new`) {
    return 'support_section.charger_models_add_heading';
  }
  if (
    normalizedPath.startsWith(`${RoutePath.CHARGER_MODELS}/`) &&
    normalizedPath !== RoutePath.CHARGER_MODELS
  ) {
    return 'support_section.charger_models_edit_title';
  }
  // Promotion detail pages use a dynamic :promotionId segment, so match by prefix.
  if (normalizedPath.startsWith('promotions/')) {
    return normalizedPath === RoutePath.PROMOTION_NEW ? 'add_promotion_title' : 'view_promotion';
  }
  return (
    routes.find((route) => route.path === baseRoute || route.path === normalizedPath)?.name || ''
  );
};

export const getRouteIcon = (fullpath: string) => {
  const baseRoute = getBaseRoute(fullpath);
  const normalizedPath = fullpath.startsWith('/') ? fullpath.slice(1) : fullpath;
  if (
    normalizedPath === RoutePath.CHARGER_MODELS ||
    (normalizedPath.startsWith(`${RoutePath.CHARGER_MODELS}/`) &&
      normalizedPath !== RoutePath.CHARGER_MODELS)
  ) {
    return ChargerEV;
  }
  if (normalizedPath.startsWith('promotions/')) {
    return PricingIcon;
  }
  return (
    routes.find((route) => route.path === baseRoute || route.path === normalizedPath)?.icon ||
    Dashboard
  );
};

export const checkIfSupportRoute = (userRole = USER_ROLE.NORMAL, routeRole = USER_ROLE.NORMAL) => {
  if (routeRole === USER_ROLE.SUPPORT) {
    return userRole === USER_ROLE.SUPPORT;
  }
  return true;
};
